import tw from 'tailwind-styled-components'

const PaginationContainer = tw.div`
flex
items-center
gap-2
`

const PageButton = tw.button`
border
border-blueTheme
text-blueTheme
h-[29px]
w-[29px]
rounded-lg
inline-flex
items-center
justify-center

`

const NumberPage = tw.span`
text-darkGray
inline-flex
items-center
justify-center
text-sm
font-light
rounded-lg
h-[29px]
w-[29px]
cursor-pointer
active:scale-95
transition-shadow
mx-1.5
`

const unstyledPage = `
text-grayLines 
border-grayLines
`

const styledPage = `
cursor-pointer
active:scale-95
transition-colors
hover:brightness-90
`

const styledNumber = `
bg-blueTheme 
text-white 
font-semibold 
hover:brightness-90
`

export {
  PaginationContainer,
  PageButton,
  NumberPage,
  unstyledPage,
  styledPage,
  styledNumber,
}
